/**
 * SaaS SPA entry point.
 *
 * Standalone React app with Supabase auth, client-side routing,
 * and API-based project management. Deployed as a static site
 * to Cloudflare Pages.
 */

import '../index.scss';
import {createRoot} from 'react-dom/client';
import {AuthProvider} from './auth';
import {SaasApp} from './SaasApp';
import {setupModuleMap} from './module-map';
import {kokoroClient} from './kokoro-client';

// Expose React/Remotion modules globally so dynamically compiled
// scene code can import them at runtime.
setupModuleMap();

// Pre-load Kokoro TTS model in the background so it's ready when the
// user opens the voiceover dialog. Downloads ~92MB (q8) on first visit,
// cached in browser Cache API for subsequent loads.
kokoroClient.preload();

const root = document.createElement('main');
document.body.appendChild(root);
document.title = 'Cascade';

createRoot(root).render(
  <AuthProvider>
    <SaasApp />
  </AuthProvider>,
);
